module.exports = "<li class=\"ubg-tab-dialog-tab-item\" (click)=\"itemClicked()\" [ngClass]=\"getTabClass()\">\n  <ng-content></ng-content>\n</li>"